import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";
import {
  AiIcon,
  EyeIcon,
  FilterIconNew,
  ManualIcon,
  ReminderFieldDetailIcon,
  SearchIcon,
} from "icons";
import moment from "moment";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { Input, Modal, Space, Spin, Table, Tooltip } from "antd";
import { useEffect, useMemo, useState } from "react";
import { ReminderDetail } from "../reminder-detail";
import {
  caseStatusColors,
  reminderStatusColors,
} from "pages/cases-dashboard/components/cases-table-layout/constants";
import { ReminderFilters } from "../reminder-filters";
import {
  dateTimeFormatted,
  getFilterArrOnSearch,
  getFormattedDate,
} from "utils/helpers";

export const ReminderHistoryTable = ({
  isLoading,
  refetchReminderHistory,
  employees,
  refetchCount,
  getReminders,
  filtersData,
  setFiltersData,
  setReminders,
  reminders,
  hideFilters,
  height,
  variant,
  minHeight,
}) => {
  const [search, setSearch] = useState("");
  const { translator } = useLanguageTranslator();
  const tableTrans = translator("caseDetail.reminder.historyTable");
  const [showFiltersPopup, setShowFiltersPopup] = useState(false);
  const [searchedReminders, setSearchedReminders] = useState([]);
  const navigate = useNavigate();

  const fieldsTrans = translator("caseDetail.form");
  const [openReminderDetail, setOpenReminderDetail] = useState(false);
  const [
    getReminderDetail,
    {
      data: getReminderDetailData,
      isLoading: getReminderDetailLoading,
      error: getReminderDetailError,
    },
  ] = UseLazyApiCallV2({
    url: "/get_reminder_by_id",
    method: "POST",
  });
  const [totalActiveFilters, setTotalActiveFilters] = useState(0);

  useEffect(() => {
    getLengthOfActiveFilters(filtersData);
  }, []);

  function getLengthOfActiveFilters(filtersData) {
    const arr = Object.values(filtersData);
    let total = 0;
    for (let index = 0; index < arr?.length; index++) {
      if (!!arr[index]) {
        total = total + 1;
      }
    }
    setTotalActiveFilters(total);
  }

  const columns = [
    {
      title: tableTrans.num,
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => {
        // const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
        // return index < 9 && currentPage === 1 ? `${index + 1}` : globalIndex;
        return index + 1;
      },
      width: "5%",
      align: "center",
    },
    {
      title: tableTrans.category,
      dataIndex: "category",
      key: "category",
      width: "10%",
      ellipsis: true,
      render: (value) => {
        return `${fieldsTrans[value] || value}`;
      },
    },
    {
      title: tableTrans.subject,
      dataIndex: "subject",
      key: "subject",
      width: "15%",
      ellipsis: true,
      align: "center",
    },
    {
      title: tableTrans.assignedBy,
      dataIndex: "name",
      key: "name",
      width: "15%",
      ellipsis: true,
      render: (value, record) => {
        return (
          <Tooltip title={record?.email} overlayStyle={{ fontSize: "13px" }}>
            {value}
          </Tooltip>
        );
      },
    },
    {
      title: tableTrans.assignedTo,
      dataIndex: "assigneeName",
      key: "assigneeName",
      width: "15%",
      ellipsis: true,
      render: (value, record) => {
        return (
          <Tooltip
            title={record?.assignedTo}
            overlayStyle={{ fontSize: "13px" }}
          >
            {value}
          </Tooltip>
        );
      },
    },
    {
      title: tableTrans.createdAt,
      dataIndex: "createdAt",
      key: "createdAt",
      width: "12%",
      ellipsis: true,

      render: (value) => {
        return value ? dateTimeFormatted(value) : null;
      },
    },
    {
      title: tableTrans.lastActivity,
      dataIndex: "lastActivity",
      key: "lastActivity",
      width: "12%",
      ellipsis: true,
      render: (value) => {
        return value ? dateTimeFormatted(value) : null;
      },
    },
    {
      title: tableTrans.dueDate,
      dataIndex: "dueDate",
      key: "dueDate",
      width: "12%",
      ellipsis: true,
      align: "center",
      render: (value) => {
        return value ? getFormattedDate(value) : null;
      },
    },

    {
      title: tableTrans.status,
      dataIndex: "status",
      key: "status",
      width: "10%",
      ellipsis: true,
      render: (value) => {
        const text = tableTrans[value];
        const { icon: Icon, color } = reminderStatusColors?.[value];
        return (
          <Space size="middle">
            <div
              className={styles.statusTag}
              style={{
                backgroundColor: color,
              }}
            >
              <ConditionalRenderer condition={Icon}>
                <Icon />
              </ConditionalRenderer>
              {text}
            </div>
          </Space>
        );
      },
    },

    {
      title: tableTrans.action,
      key: "action",
      width: "5%",
      align: "center",
      render: (_, record) => (
        <>
          <Space size="small">
            <ConditionalRenderer condition={variant === "pending"}>
              <Tooltip
                title={`${translator("caseDetailLabel")}: ${record?.caseId} `}
              >
                <div
                  style={{ display: "flex", gap: "5px" }}
                  onClick={() => handleGoToCase(record?.caseId)}
                >
                  <button className={styles.viewDetailsBtn}>
                    <ReminderFieldDetailIcon
                      style={{ height: "13px", width: "13px" }}
                      // onClick={() => onEditNote(record)}
                    />
                  </button>
                </div>
              </Tooltip>
            </ConditionalRenderer>
            <Tooltip title={translator("caseDetail.reminder.reminderDetail")}>
              <div
                style={{ display: "flex", gap: "5px" }}
                onClick={() => handleClickViewReminder(record?.id)}
              >
                <button className={styles.viewDetailsBtn}>
                  <EyeIcon
                    style={{ height: "13px", width: "13px" }}
                    // onClick={() => onEditNote(record)}
                  />
                </button>
              </div>
            </Tooltip>
          </Space>
        </>
      ),
    },
  ];

  function closeReminderDetail() {
    setOpenReminderDetail(false);
  }

  function showReminderDetailPopup() {
    setOpenReminderDetail(true);
  }

  async function handleClickViewReminder(reminder_id) {
    showReminderDetailPopup();

    try {
      await getReminderDetail({
        params: {
          reminder_id,
        },
      });
    } catch (error) {
      console.log({ error });
    }
  }
  function handleGoToCase(caseId) {
    navigate(`/cases/${caseId}`);
  }

  function getsearchedReminders(search) {
    if (!search) {
      setSearchedReminders([...reminders] || []);
      return;
    }
    if (search) {
      const searchableFields = ["assigneeName", "name", "subject"];
      const filtered = getFilterArrOnSearch({
        data: [...reminders] || [],
        searchableFields,
        searchValue: search,
      });

      setSearchedReminders([...filtered]);
    }
  }

  useEffect(() => {
    getsearchedReminders(search);
  }, [search]);

  // get_email_reminders

  function onCloseReminderFilters() {
    setShowFiltersPopup(false);
  }

  return (
    <>
      <ConditionalRenderer condition={!hideFilters}>
        <div className={styles.searchAndFilters}>
          <Input
            type="text"
            placeholder={translator("Search")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "346px", height: "40px" }}
            prefix={<SearchIcon height={11} width={11} />}
            maxLength={40}
          />
          <div
            className={styles.filterIcon}
            onClick={() => setShowFiltersPopup(true)}
          >
            <FilterIconNew />
            <div className={styles.number}>{totalActiveFilters}</div>
          </div>
        </div>
      </ConditionalRenderer>
      <div
        className={`${styles.tableContainer} ${variant === "pending" ? styles.pending : ""}`}
        style={{ marginTop: "10px" }}
      >
        <Spin spinning={isLoading}>
          <Table
            columns={columns}
            dataSource={search ? searchedReminders : reminders}
            rowClassName={styles.row}
            scroll={{
              y: height || "61dvh",
            }}
            style={{ width: "100%", minHeight: minHeight || `65dvh` }}
            className={styles.userListTable}
            sticky={true}
            pagination={false}
          />
        </Spin>
      </div>
      <Modal
        destroyOnClose
        // title="Set Reminder"
        open={openReminderDetail}
        onCancel={closeReminderDetail}
        footer={null}
        centered
        width="98dvw"
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            height: "98dvh",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <ReminderDetail
          reminderData={getReminderDetailData?.reminder}
          closeReminderDetail={closeReminderDetail}
          refetchReminderHistory={refetchReminderHistory}
          loading={getReminderDetailLoading}
          refetchCount={refetchCount}
        />
      </Modal>
      <Modal
        title={translator("selectFilters")}
        destroyOnClose
        open={showFiltersPopup}
        onCancel={onCloseReminderFilters}
        footer={null}
        centered
        width={variant === "pending" ? "55dvw" : "70dvw"}
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            borderRadius: "20px",
            minHeight: "250px",
            overflowY: "auto",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <ReminderFilters
          employees={employees}
          getReminders={getReminders}
          filtersData={filtersData}
          setFiltersData={setFiltersData}
          refetchReminderHistory={refetchReminderHistory}
          variant={variant}
          onClose={onCloseReminderFilters}
          getLengthOfActiveFilters={getLengthOfActiveFilters}
        />
      </Modal>
    </>
  );
};
